module.exports = __webpack_public_path__ + "img/logo.c9e2657b.png";